import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_USER_ACCESS,
  LATEST_DATA,
  OLD_LATEST_DATA,
  USERPROJECT_GET,
} from "../services/constants";
import { handleInvitedUserProject, makeUnique } from "../helperJs/helper";
import { ZustandStore } from "../store/zustand-store";
import {
  getLanguageName,
  getDomainNameAndLang,
} from "../helperJs/getCountryFlag";

const GetLatestData = React.memo(() => {
  const dispatch = useDispatch();
  const {
    keyword_old_data,
    keyword_latest_data,
    keyword_loc_data,
    all_loc_data,
    userAccessData,
  } = ZustandStore((state) => state);
  const loading = useSelector((state) => state.loading);
  const email = localStorage.getItem("admin_mail");
  const user_email = useSelector((state) => state.email);

  // user projects
  const userallprojectdetails = useSelector(
    (state) => state.userallprojectdetails
  );
  const userselectedprojectallid = useSelector(
    (state) => state.userselectedprojectallid
  );
  // user select project location
  const currentlocationcode = useSelector((state) => state.currentlocationcode);
  const currentlocation = useSelector((state) => state.currentlocation);

  // user select domain, device type, date for old data
  const deviceType = useSelector((state) => state.devicetype);
  const websiteurl = useSelector((state) => state.websiteurl);
  const customDate = useSelector((state) => state.selectcustomdate);

  const getUserAccess = async () => {
    if (userAccessData?.length > 0) return userAccessData;
    const user_type = localStorage.getItem("user_type");
    const Is_organization = user_type === "organization";
    if (!Is_organization) return;
    try {
      const response = await axios.get(GET_USER_ACCESS(user_email));
      ZustandStore.setState({
        userAccessData: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching user access data`, error);
      return [];
    }
  };

  const callLatestDataApi = async (latestData) => {
    try {
      const response = await axios.get(LATEST_DATA(latestData));
      return { location: latestData.location_name, data: response.data };
    } catch (error) {
      console.error(
        `Error fetching data for ${latestData.location_name}:`,
        error
      );
      return { location: latestData.location_name, error: true };
    }
  };

  const callOldDataApi = async (latestData) => {
    try {
      const response = await axios.get(OLD_LATEST_DATA(latestData));
      return { location: latestData.location_name, data: response.data };
    } catch (error) {
      console.error(
        `Error fetching data for ${latestData.location_name}:`,
        error
      );
      return { location: latestData.location_name, error: true };
    }
  };

  const userOldDataUpdate = (data, filterDeviceType, index) => {
    const filterDeviceTypeData = filterDeviceType?.filter((loc) => {
      return loc.location_name === data?.location;
    });

    let oldDataCalculate = {
      INDEX: index,
      LOCATION: data?.location,
      PREVIOUSALLOLDDATA: [],
      ALLOLDKEYWORDDATA: [],
      OLDKEYWORDDATA: [],
    };

    const old_data = data?.data;
    if (old_data?.length !== 0) {
      oldDataCalculate.PREVIOUSALLOLDDATA = old_data?.map((obj) => {
        const keywordSet = new Set();
        const updatedObjData = obj.data.filter((item) => {
          if (!keywordSet.has(item.keyword)) {
            keywordSet.add(item.keyword);
            return true;
          }
          return false;
        });
        return { ...obj, data: updatedObjData };
      });

      oldDataCalculate?.PREVIOUSALLOLDDATA?.map((upRes, key) => {
        const UserAllKeywordResult = [];
        const UserAllPendingResult = [];
        const KeywordData = [];

        filterDeviceTypeData?.forEach((detail) => {
          detail.keyword &&
            detail.keyword.forEach((onlyKeyword) => {
              const foundKeyword = upRes.data.find(
                (rankKeyword) => rankKeyword.keyword === onlyKeyword
              );
              if (foundKeyword) {
                UserAllKeywordResult.push(foundKeyword);
                KeywordData.push(foundKeyword.data[0]);
              } else {
                UserAllPendingResult.push(onlyKeyword);
              }
            });
        });

        oldDataCalculate.ALLOLDKEYWORDDATA.push({
          data: KeywordData,
          date: upRes.date,
          month: upRes.month,
          year: upRes.year,
        });
      });

      oldDataCalculate.OLDKEYWORDDATA =
        oldDataCalculate.ALLOLDKEYWORDDATA[
          oldDataCalculate.ALLOLDKEYWORDDATA?.length - 1
        ]?.data;

      return oldDataCalculate;
    } else {
      return oldDataCalculate;
    }
  };

  const userLatestDataUpdate = (data, filterDeviceType, index) => {
    const filterDeviceTypeData = filterDeviceType?.filter((loc) => {
      return loc.location_name === data?.location;
    });
    let latestDataCalculate = {
      INDEX: index,
      LOCATION: data?.location,
      USERCOMPATITORS: [],
      SELECTEDPROJECTNEWDATA: [],
      KEYWORDDATA: [],
      USERALLKEYWORDRESULT: [],
      USERALLPENDINGRESULT: [],
    };

    const latest_data = data?.data;
    latestDataCalculate.USERCOMPATITORS = data?.data[0]?.competitors || [];
    latestDataCalculate.SELECTEDPROJECTNEWDATA = data?.data;
    const selectProjectAllKeyword_Data = data?.data[0]?.data;
    const initDataArr = data?.data?.[0]?.initial_data?.[0] || [];
    const INITIALDATA =
      initDataArr?.data?.map((item) => {
        return {
          keyword: item.keyword,
          rank: item.data?.[0].rank_group,
          date:
            initDataArr?.date +
            "-" +
            initDataArr?.month +
            "-" +
            initDataArr?.year,
          time: initDataArr?.time,
        };
      }) || [];

    if (latest_data.length !== 0) {
      filterDeviceTypeData &&
        filterDeviceTypeData.forEach((detail) => {
          detail.keyword &&
            detail.keyword.forEach((onlyKeyword) => {
              const foundKeyword = selectProjectAllKeyword_Data.find(
                (rankKeyword) => rankKeyword.keyword === onlyKeyword
              );
              const foundIniTialRankKeyword = INITIALDATA?.find(
                (item) => item.keyword === onlyKeyword
              );
              if (foundKeyword) {
                if (foundIniTialRankKeyword) {
                  foundKeyword["initial_rank"] = {
                    rank: foundIniTialRankKeyword.rank,
                    date: foundIniTialRankKeyword.date,
                    time: foundIniTialRankKeyword.time,
                  };
                }
                foundKeyword["location"] = detail?.location_name;
                latestDataCalculate.USERALLKEYWORDRESULT.push(foundKeyword);
                latestDataCalculate.KEYWORDDATA.push(foundKeyword.data[0]);
              } else {
                latestDataCalculate.USERALLPENDINGRESULT.push(onlyKeyword);
              }
            });
        });
    } else {
      latestDataCalculate.USERALLPENDINGRESULT =
        filterDeviceTypeData[0]?.keyword || [];
    }
    return latestDataCalculate;
  };

  const showLoaderWithDelay = () => {
    setTimeout(() => {
      dispatch({ type: "SHOWLOADER", payload: false });
    }, 500);
  };

  function getMatchingProjects(allProjects, accessProjects) {
    // Handle cases where inputs are null, undefined, or not arrays
    if (!Array.isArray(allProjects) || !Array.isArray(accessProjects)) {
      return [];
    }

    // Convert allProjects into a Set for faster lookup
    const projectSet = new Set(allProjects);

    // Filter accessProjects that exist in the main project set
    return accessProjects.filter((project) => projectSet.has(project));
  }

  const handleAccessProject = (access_proj_config) => {
    if (access_proj_config.access_data?.length === 0) {
      if (websiteurl === null) {
        if (access_proj_config.last_project != null) {
          dispatch({
            type: "WEBSITEURL",
            payload: access_proj_config.last_project,
          });
        } else {
          sessionStorage.setItem(
            "LAST_PRPJECT_SELECTED",
            access_proj_config.firstProject
          );
          dispatch({
            type: "WEBSITEURL",
            payload: access_proj_config.firstProject,
          });
        }
      }
    } else {
      const filteredProjects = handleInvitedUserProject(
        "True",
        access_proj_config.access_data
      );
      const matchingProjects = getMatchingProjects(
        access_proj_config?.allProject || [],
        filteredProjects
      );
      const first_proj =
        matchingProjects?.length > 0
          ? matchingProjects?.[0]
          : access_proj_config.allProject?.[0];

      if (websiteurl === null) {
        if (access_proj_config.last_project != null) {
          dispatch({
            type: "WEBSITEURL",
            payload: access_proj_config.last_project,
          });
        } else {
          sessionStorage.setItem("LAST_PRPJECT_SELECTED", first_proj);
          dispatch({
            type: "WEBSITEURL",
            payload: first_proj,
          });
        }
      }
    }
  };

  const userDataUpdate = async (userAllProjectDetails) => {
    dispatch({ type: "SHOWLOADER", payload: true });
    dispatch({ type: "KEYWORDDATA", payload: [] });
    dispatch({ type: "OLDKEYWORDDATA", payload: [] });
    dispatch({ type: "USERALLKEYWORDRESULT", payload: [] });
    dispatch({ type: "RANKMOVEDUP", payload: null });
    dispatch({ type: "RANKMOVEDDOWN", payload: null });
    dispatch({ type: "USERALLPROJECTNAME", payload: [] });

    const access_data = await getUserAccess();
    const access_project_data = access_data?.[0]?.access || [];
    const userAllProject = userAllProjectDetails?.flatMap((res) => res.Project);

    const weburlLanguageArray = userAllProjectDetails?.map((item) => {
      const project = item.Project[0];
      return `${project.weburl}, ${getLanguageName(project.language_code)}`;
    });
    if (weburlLanguageArray.length > 0) {
      dispatch({ type: "USERALLPROJECTNAME", payload: weburlLanguageArray });
    }

    //----------------------user current selected project id  -----------//
    const selectedProject = userAllProjectDetails?.find((item) => {
      const project = item.Project[0];
      const weburlLang = `${project.weburl}, ${getLanguageName(
        project.language_code
      )}`;
      return weburlLang === websiteurl;
    });

    if (selectedProject) {
      const projectId = Number(selectedProject?.id);
      dispatch({ type: "USERSELECTEDPROJECTALLID", payload: [projectId] });
    }

    if (userAllProject.length !== 0) {
      dispatch({ type: "ISPROJECT", payload: true });
      dispatch({ type: "NOTLOADING" });

      // ----------first project name of user---------- //
      const firstProject = `${userAllProject[0]?.weburl}, ${getLanguageName(
        userAllProject[0]?.language_code
      )}`;
      const firstProjectDeviceType = userAllProject[0]?.deviceType;
      const last_project = sessionStorage.getItem("LAST_PRPJECT_SELECTED");
      if (deviceType === null) {
        dispatch({ type: "DEVICETYPE", payload: firstProjectDeviceType });
      }

      const access_proj_config = {
        access_data: access_project_data,
        last_project: last_project,
        firstProject: firstProject,
        allProject: weburlLanguageArray,
      };

      handleAccessProject(access_proj_config);
      //----------user selected project all details ----------//

      dispatch({
        type: "USERCURRENTPROJECTLOCATION",
        payload: selectedProject?.Project || [],
      });

      if (currentlocationcode === null && websiteurl !== null) {
        dispatch({
          type: "CURRENTLOCATIONCODE",
          payload: "All Locations",
        });
        dispatch({
          type: "CURRENTLOCATION",
          payload: "All Locations",
        });
      }

      // ----------selected project data by LocationCode ---------- //
      const country_Based_Data = selectedProject?.Project?.filter(
        (countrybased) =>
          currentlocationcode === "All Locations"
            ? countrybased
            : countrybased.location_code === currentlocationcode
      );

      // ---------- Start getting selected project data by  LocationCode with device type ---------- //
      const filterDeviceTypeData = country_Based_Data?.filter(
        (type) => type.deviceType === deviceType
      );

      const project_language_code =
        selectedProject?.Project?.[0]?.language_code;

      if (currentlocationcode && currentlocation && websiteurl) {
      
        const domain = getDomainNameAndLang(websiteurl);
        const website_domain = domain?.domain;
        if (
          currentlocation === keyword_loc_data &&
          keyword_old_data?.length > 0 &&
          keyword_latest_data?.length > 0
        ) {
          ZustandStore.setState({
            keyword_old_data: keyword_old_data,
            keyword_latest_data: keyword_latest_data,
            keyword_loc_data: keyword_loc_data,
          });
          showLoaderWithDelay();
        } else if (
          currentlocation === "All Locations" &&
          all_loc_data?.length === 0
        ) {
          ZustandStore.setState({
            keyword_loc_data: "All Locations",
          });

          const getCountry = filterDeviceTypeData
            ?.map((item) => {
              if (item.keyword?.length === 0) return null;
              return {
                location_name: item.location_name,
                location_code: item.location_code,
              };
            })
            .filter(Boolean);

          let uniqueCountry = makeUnique(getCountry);

          const allPromises = uniqueCountry?.map((location) => {
            const latestData = {
              id: userselectedprojectallid[0], // project data id
              email: email,
              deviceType: deviceType, // default is desktop
              location_code: location?.location_code, // country code
              weburl: website_domain, // selected domain
              location_name: location?.location_name, // country name
              language_code: project_language_code || domain.code,
            };

            const oldData = {
              ...latestData,
              days: customDate?.day,
            };

            return Promise.allSettled([
              callLatestDataApi(latestData),
              callOldDataApi(oldData),
            ]);
          });
          const results = await Promise.all(allPromises);

          const successfulLatestData = results
            ?.map((result) => result[0])
            .filter((result) => result.status === "fulfilled")
            .map((result) => result.value);

          const successfulOldData = results
            ?.map((result) => result[1])
            .filter((result) => result.status === "fulfilled")
            .map((result) => result.value);

          if (successfulLatestData) {
            const data = successfulLatestData?.map((loc, index) => {
              return userLatestDataUpdate(
                successfulLatestData?.[index],
                filterDeviceTypeData,
                index
              );
            });

            ZustandStore.setState({
              keyword_latest_data: data,
            });
          }

          if (successfulOldData) {
            const data = successfulOldData?.map((loc, index) => {
              return userOldDataUpdate(
                successfulOldData?.[index],
                filterDeviceTypeData,
                index
              );
            });

            ZustandStore.setState({
              keyword_old_data: data,
            });
          }
          showLoaderWithDelay();
        } else if (all_loc_data?.length > 0) {
          const data = all_loc_data?.[0];
          if (currentlocation === "All Locations") {
            ZustandStore.setState({
              keyword_old_data: data?.keyword_old_data,
              keyword_latest_data: data?.keyword_latest_data,
              keyword_loc_data: currentlocation,
            });
          } else {
            const old_data = data?.keyword_old_data?.filter((item) => {
              return item.LOCATION === currentlocation;
            });
            const new_data = data?.keyword_latest_data?.filter((item) => {
              return item.LOCATION === currentlocation;
            });
            ZustandStore.setState({
              keyword_old_data: old_data,
              keyword_latest_data: new_data,
              keyword_loc_data: currentlocation,
            });
          }
          showLoaderWithDelay();
        } else {
          ZustandStore.setState({
            keyword_loc_data: currentlocation,
            keyword_old_data: [],
            keyword_latest_data: [],
          });
          const latestData = {
            id: userselectedprojectallid[0], // project data id
            email: email,
            deviceType: deviceType, // default is desktop
            location_code: currentlocationcode, // country code
            weburl: website_domain, // selected domain
            location_name: currentlocation,
            days: customDate?.day, // country name
            language_code: project_language_code || domain.code,
          };
          const [getLatestData, getOldData] = await Promise.all([
            callLatestDataApi(latestData),
            callOldDataApi(latestData),
          ]);
          if (getOldData?.data) {
            const data = userOldDataUpdate(getOldData, filterDeviceTypeData, 0);
            ZustandStore.setState({
              keyword_old_data: [data],
            });
          }
          if (getLatestData?.data) {
            const data = userLatestDataUpdate(
              getLatestData,
              filterDeviceTypeData,
              0
            );
            ZustandStore.setState({
              keyword_latest_data: [data],
            });
          }
          showLoaderWithDelay();
        }
      }
    } else {
      sessionStorage.removeItem("LAST_PRPJECT_SELECTED");
      dispatch({ type: "ISPROJECT", payload: false });
      dispatch({ type: "WEBSITEURL", payload: null });
      dispatch({ type: "NOTLOADING" });
    }
  };

  const getUserProject = () => {
    if (email == null) return;
    axios
      .get(USERPROJECT_GET(email))
      .then((response) => {
        dispatch({
          type: "USERALLPROJECTDETAILS",
          payload: response.data?.data,
        });
        userDataUpdate(response.data?.data);
      })
      .catch((error) => console.log("error while getting data", error));
  };

  useEffect(() => {
    if (userallprojectdetails?.length > 0) {
      userDataUpdate(userallprojectdetails); // need to update on refresh, add proj and delete proj
    } else {
      getUserProject();
    }
  }, [
    email,
    websiteurl,
    deviceType,
    currentlocationcode,
    customDate,
    loading,
    all_loc_data,
  ]);

  return null;
});

export default GetLatestData;
